import { getApiBaseUrl } from '../utils/apiBaseUrl';
import { DeleteFeedbackResponse } from './FeedbackDeleteAdmin';

export interface DeleteReportIssueResponse {
  message: string;
}

export const deleteReportIssueAdmin = async (
  id: number,
  token: string
): Promise<DeleteReportIssueResponse> => {
  const baseUrl = getApiBaseUrl();

  const response = await fetch(`${baseUrl}/api/Admin/DeleteReportIssueAsync/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to delete report: ${response.status}`);
  }

  const data: DeleteReportIssueResponse = await response.json();
  return data;
};